import { type MouseEventHandler, useState } from "react";

import type { PropsWithStyleX } from "@/styles/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

import Typography from "../Typography";
import Button from "../button";

export type ReadMoreTextProps = PropsWithStyleX & {
    className?: string;
    longDescription: string;
    shortDescription?: string;
    startShort: boolean;
    shortButtonText: string;
    longButtonText: string;
    dataTestId?: string;
};

export default function ReadMoreText(props: ReadMoreTextProps) {
    const [isShort, setIsShort] = useState(props.startShort);

    if (!props.shortDescription && !props.longDescription) {
        return null;
    }

    const toggleText: MouseEventHandler<HTMLButtonElement> = (ev) => {
        ev.preventDefault();

        setIsShort(!isShort);

        return false;
    };

    const innerText =
        isShort && props.shortDescription
            ? `${props.shortDescription}`
            : `${props.longDescription || props.shortDescription}`;

    return (
        <div {...stylex.props(props.styleX)} data-testid={props.dataTestId}>
            <Typography dangerouslySetInnerHTML={{ __html: innerText }} fontStyle="BodyS" />
            {props.shortDescription && props.longDescription && (
                <>
                    <br />
                    <Button as="button" onClick={toggleText} size="None" variant="transparent" type="button">
                        {isShort ? props.shortButtonText : props.longButtonText}
                    </Button>
                </>
            )}
        </div>
    );
}
